import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { GoodsFilter, GoodsResponse } from '../../modules/Goods/types';
import { useCustomToast } from '../../components';
import { WarehouseReqAPI } from '../../modules/WarehouseView/api';



// Query key for caching
const keyQuery = ['refunds'];

export const useFetchWarehouseRequests = (filters?: Partial<GoodsFilter>) => {
  return useQuery<GoodsResponse, Error>({
    queryKey: [...keyQuery, filters || {}],
    queryFn: ({ queryKey }) => {
      const [, filters] = queryKey;
      return WarehouseReqAPI.gets(filters);
    },
    enabled: true,
  });
};
